

























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditConfig from '@/components/flux/edit/EditConfig.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'

@Component({
  name: 'ReadConfig',    
  components:{EditConfig},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    },
    mkpEditable:{
      type:Boolean,
      default:true      
    },
    editable:{
      type:Boolean,
      default:true      
    },
    mkpVisible:{
      type:Boolean,
      default:true      
    }    
  }
})
export default class ReadConfig extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean
  private mkpEditable!:boolean
  private editable!:boolean
  private mkpVisible!:boolean

  edit() { 
    (this.$refs.editConfig as EditConfig).edit(this.flux)
  }

}
